module.exports = __webpack_public_path__ + "static/telegrotesknext-regular-webfont-bb558628edb91f33f081e2fab27f5cc7.woff2";